import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import starIcon from '../../assets/images/star-icon.png'

const TeamMember = () => {
  const { teams } = useStaticQuery(
    graphql`
      query {
        teams: allContentfulTeams(sort: { fields: createdAt, order: ASC }) {
          edges {
            node {
              name
              position
              image {
                fluid(maxWidth: 580) {
                  ...GatsbyContentfulFluid_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    `
  )

  if (!teams) {
    return null
  }

  return (
    <section className="scientist-area pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="team" />
            Team Members
          </span>
          <h2>Our Awesome Team</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna.
          </p>
        </div>

        <div className="row">
          {teams.edges.map((team, index) => {
            return (
              <div key={index} className="col-lg-3 col-sm-6">
                <div className="single-scientist-item-box">
                  <div className="image">
                    <Img
                      loading="eager"
                      fadeIn={false}
                      fluid={team.node.image.fluid}
                    />

                    <ul className="social">
                      <li>
                        <Link
                          to="#"
                          className="d-block"
                          onClick={(e) => e.preventDefault()}
                          aria-label="facebook"
                        >
                          <i className="bx bxl-facebook"></i>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="d-block"
                          onClick={(e) => e.preventDefault()}
                          aria-label="twitter"
                        >
                          <i className="bx bxl-twitter"></i>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="d-block"
                          onClick={(e) => e.preventDefault()}
                          aria-label="instagram"
                        >
                          <i className="bx bxl-instagram"></i>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="d-block"
                          onClick={(e) => e.preventDefault()}
                          aria-label="linkedin"
                        >
                          <i className="bx bxl-linkedin"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="content">
                    <h3>{team.node.name}</h3>
                    <span>{team.node.position}</span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default TeamMember
